"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _axios = _interopRequireDefault(require("axios"));
var echarts = _interopRequireWildcard(require("echarts"));
var _InfoItem = _interopRequireDefault(require("@/components/Store/InfoItem.vue"));
var _storeReport = require("@/http/interface/sfe/storeReport");
var _methods = require("./methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 引入图表
/** package */

/** components */

/** services */

/** utils */

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    InfoItem: _InfoItem.default
  },
  props: {
    // storeCode 门店code(即rtl_sap_id)
    storecode: {
      type: String,
      default: ''
    },
    // retailorStoreInfoPk 门店主键
    storeid: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      /** tpp form */
      ssbtypeOptions: [{
        name: this.$t('storeComponents.title.GY'),
        code: 'GY'
      }, {
        name: this.$t('storeComponents.title.CP'),
        code: 'CP'
      }],
      // 枚举，目前写死
      tppForm: {
        type: '1',
        // 类型 月度、季度、年度
        brand: 'GY',
        // 品牌 目前写死option，并写死一个默认值
        value: ''
      },
      tppSourceApi: null,
      tppInfo: {},
      /** order form */
      orderForm: {
        month: curDateTree.month // 月份 demo 202307
      },
      /** 订单情况 */
      orderStatus: {
        salesTargetQty: 0,
        confirmedQty: 0,
        orderQty: 0
      },
      orderSourceApi: null,
      /** echart */
      TPPChat: null,
      // TPP达成量 图表
      MASChat: null,
      // 月度实际销售情况 图表
      QASChat: null // 订单情况统计 图表
    };
  },
  computed: {
    // 时间lable格式化
    formatTimeLabel: function formatTimeLabel() {
      var tree = {
        1: this.$t('storeComponents.form.month'),
        2: this.$t('storeComponents.form.quarter'),
        3: this.$t('storeComponents.form.year')
      };
      var type = this.tppForm.type;
      if (type && tree[type]) {
        return tree[type];
      } else {
        return '';
      }
    },
    // api请求用到的全局部分的params
    baseParams: function baseParams() {
      var roles = this.$store.getters.roles || []; // 当前角色
      var _ref = this.$store.state.user || {},
        userInfo = _ref.userInfo;
      var empNo = userInfo.empNo || '';
      return {
        empNo: empNo,
        // 工号
        roleCode: roles[0] // 角色
      };
    },
    // 进度条百分比
    orderPecent: function orderPecent() {
      var _this$orderStatus = this.orderStatus,
        salesTargetQty = _this$orderStatus.salesTargetQty,
        confirmedQty = _this$orderStatus.confirmedQty,
        orderQty = _this$orderStatus.orderQty;
      return {
        salesTargetQty: salesTargetQty ? 100 : 0,
        confirmedQty: this.getPercent(confirmedQty, salesTargetQty),
        orderQty: this.getPercent(orderQty, salesTargetQty)
      };
    }
  },
  watch: {
    'tppForm.type': {
      deep: true,
      immediate: true,
      handler: function handler(val, oldVal) {
        // console.log(1, val, oldVal)
        var typeNum = Number(val);
        if (typeNum === 1) {
          // 月度
          this.tppForm.value = curDateTree.month;
        } else if (typeNum === 2) {
          // 季度
          this.tppForm.value = curDateTree.quarter;
        } else if (typeNum === 3) {
          // 年度
          this.tppForm.value = curDateTree.year;
        }
      }
    },
    'tppForm.brand': {
      deep: true,
      handler: function handler(val, oldVal) {
        // console.log(2, val, oldVal)
        if (val !== oldVal) {
          this.initEcharts();
        }
      }
    },
    'tppForm.value': {
      deep: true,
      handler: function handler(val, oldVal) {
        // console.log(2, val, oldVal)
        if (val !== oldVal) {
          this.initTPPCompRate();
        }
      }
    },
    'orderForm.month': {
      deep: true,
      handler: function handler(val, oldVal) {
        if (val !== oldVal) {
          this.initoOrderStatus();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更刷新图表
      this.initEcharts();
    }
  },
  mounted: function mounted() {
    // echart初始化
    this.TPPChat = echarts.init(document.getElementById('id_tppCompRate'));
    this.MASChat = echarts.init(document.getElementById('id_monthlyActualSales'));
    this.QASChat = echarts.init(document.getElementById('id_quarterActualSales'));
    // 因为依赖外部数据，所以初始化操作放在外部读取完门店数据后
    // this.$nextTick(() => {
    //   // 画图
    //   this.initEcharts()
    // })
  },
  methods: {
    // 初始化 所有图表
    initEcharts: function initEcharts() {
      this.initTPPCompRate();
      this.initMonthlyActualSales();
      this.initQuarterActualSales();
      this.initoOrderStatus();
    },
    // 获取百分比
    getPercent: function getPercent(z, m) {
      if (z && z > m) {
        // 分子存在并且大于分母，不管分母是不是0，就是100进度
        return 100;
      } else if (z && m) {
        // const num = Math.ceil(z / m * 100)
        return Math.ceil(z / m * 100);
      } else {
        return 0;
      }
    },
    // 初始化 TPP达成量
    initTPPCompRate: function initTPPCompRate() {
      var _this = this;
      var _this$tppForm = this.tppForm,
        brand = _this$tppForm.brand,
        value = _this$tppForm.value;
      if (!brand || !value) {
        // 所有参数必传
        console.log('tpp 所有参数必传', this.tppForm);
        return false;
      }
      if (this.tppSourceApi) {
        this.tppSourceApi.cancel('cancel');
      }
      this.tppSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)({
        storeCode: this.storecode,
        // 门店code(即rtl_sap_id)
        retailorStoreInfoPk: this.storeid
      }, this.tppForm);
      (0, _storeReport.getTPPSalesReport)(params, this.tppSourceApi.token).then(function (res) {
        var data = res.data || {};
        var tppInfo = {
          tppTargetCount: data.tppTargetCount || 0,
          confirmedCount: data.confirmedCount || 0,
          unFinishedCount: data.unFinishedCount || 0,
          rate: data.rate || 0
        };
        (0, _methods.drawTpp)(_this.TPPChat, tppInfo);
        // 数据
        _this.tppInfo = tppInfo;
      });
    },
    // 初始化 月度实际销售情况
    initMonthlyActualSales: function initMonthlyActualSales() {
      var _this2 = this;
      var params = {
        storeCode: this.storecode,
        // 门店code(即rtl_sap_id)
        brand: this.tppForm.brand
      };
      (0, _storeReport.getActualMonthSalesReport)(params).then(function (res) {
        var data = res.data || {};
        (0, _methods.drawMonthly)(_this2.MASChat, {
          monthXAxisData: data.xAxis || [],
          monthSeriesData: data.series || []
        });
      });
    },
    // 初始化 季度实际销售情况
    initQuarterActualSales: function initQuarterActualSales() {
      var _this3 = this;
      var params = {
        storeCode: this.storecode,
        // 门店code(即rtl_sap_id)
        brand: this.tppForm.brand
      };
      (0, _storeReport.getActualQuarterSalesReport)(params).then(function (res) {
        var data = res.data || {};
        (0, _methods.drawQuarter)(_this3.QASChat, {
          quarterXAxisData: data.xAxis || [],
          quarterSeriesData: data.series || []
        });
      });
    },
    // 初始化 订单情况
    initoOrderStatus: function initoOrderStatus() {
      var _this4 = this;
      var month = this.orderForm.month;
      if (!month) {
        // 所有参数必传
        console.log('订单情况 所有参数必传', this.orderForm);
        return false;
      }
      if (this.orderSourceApi) {
        this.orderSourceApi.cancel('cancel');
      }
      this.orderSourceApi = _axios.default.CancelToken.source();
      var params = (0, _objectSpread2.default)({
        storeCode: this.storecode,
        // 门店code(即rtl_sap_id)
        retailorStoreInfoPk: this.storeid,
        // 门店主键
        brand: this.tppForm.brand
      }, this.orderForm);
      (0, _storeReport.getOrderSalesReport)(params, this.orderSourceApi.token).then(function (res) {
        var data = res.data || {};
        var _ref2 = data || {},
          salesTargetQty = _ref2.salesTargetQty,
          confirmedQty = _ref2.confirmedQty,
          orderQty = _ref2.orderQty;
        _this4.orderStatus.salesTargetQty = salesTargetQty || 0;
        _this4.orderStatus.confirmedQty = confirmedQty || 0;
        _this4.orderStatus.orderQty = orderQty || 0;
      });
    },
    // 移除单位（当目标数为0，达成量不为0，特殊显示）
    removeUnit: function removeUnit(tppInfo) {
      var _ref3 = tppInfo || {},
        rate = _ref3.rate,
        confirmedCount = _ref3.confirmedCount,
        tppTargetCount = _ref3.tppTargetCount;
      var rateStr = rate ? String(rate) : '';
      if (!tppTargetCount && confirmedCount) {
        return '-';
      } else {
        return rateStr.replaceAll('%', '');
      }
    }
  }
};